/* @flow */
import { ContentType } from './base';

type ContentElementType = 'text' | 'rich_text' | 'asset' | 'multiple_choice' | 'modular_content';

const contentTypes: Class<ContentType>[] = [];

export class ContentElement {
  type: ContentElementType;
  name: string;

  constructor(data: Object) {
    this.type = data.type;
    this.name = data.name;
  }
}

export class Text extends ContentElement {
  value: string;

  constructor(data: Object) {
    super(data);

    if (data) {
      this.value = data.value;
    }
  }
}

export class RichText extends ContentElement {
  images: Object;
  links: Object;
  /**
   * This is the Inner HTML required to be injected into the element encapsulating this rich text
   */
  value: string;

  constructor(data: Object) {
    super(data);

    this.images = data.images;
    this.links = data.links;
    this.value = data.value;
  }
}

export type AssetItem = {
  name: string,
  description: string,
  type: string,
  size: number,
  url: string,
  width: number,
  height: number,
};
export class Asset extends ContentElement {
  value: AssetItem[];

  constructor(data: Object) {
    super(data);

    this.value = data.value;
  }
}

export type MultipleChoiceItem = {
  name: string,
  codename: string,
};
export class MultipleChoice extends ContentElement {
  value: MultipleChoiceItem[];

  constructor(data: Object) {
    super(data);

    this.value = data.value;
  }
}

export class LinkedItems<T> extends ContentElement {
  // When no modular data item is found for the linked element, the string ID will be inserted
  // REVIEW: Perhaps we should consider keeping the unmatched IDs outside of the value
  value: (T | string)[];

  constructor(data: Object, modularData?: Object) {
    super(data);

    if (
      data &&
      data.type === 'modular_content' &&
      data.value &&
      typeof data.value.map === 'function'
    ) {
      this.value = data.value.map(elementId => {
        if (modularData) {
          const matchedModularDataItem = modularData[elementId];
          if (matchedModularDataItem) {
            const ContentTypeClass = contentTypes.find(
              Type =>
                matchedModularDataItem.system &&
                Type.typeName === matchedModularDataItem.system.type
            );

            if (ContentTypeClass) {
              return new ContentTypeClass(matchedModularDataItem, modularData);
            }
          }
        }

        return elementId;
      });
    }
  }
}

export const setAvailableContentTypes = (types: Class<ContentType>[]) => {
  contentTypes.push(...types);
};
